/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SunResponse } from '../../models/sun-response';

export interface GetSunriseSunset$Params {
  location_id: string;
  at?: string;
}

export function getSunriseSunset(http: HttpClient, rootUrl: string, params: GetSunriseSunset$Params, context?: HttpContext): Observable<StrictHttpResponse<SunResponse>> {
  const rb = new RequestBuilder(rootUrl, getSunriseSunset.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('at', params.at, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SunResponse>;
    })
  );
}

getSunriseSunset.PATH = '/locations/{location_id}/weather/sun';
